import { writable } from 'svelte/store';
export let checked = writable(false);
export function faceTrackerValueChange(val, value) {
    checked.set(val);
}
